// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"61c7fc2f","239":"86d7dab4","455":"c97b055f","806":"e7fcebb3","977":"87b70058"}[chunkId] + ".chunk.js";
};